import React, { useEffect, useState } from 'react';
import UserTopbar from '../component/UserTopbar'
import { useParams, useNavigate } from "react-router-dom";
import axios from 'axios';
import Moment from 'react-moment';
import { TbCheckbox } from "react-icons/tb";
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { BiSearchAlt } from "react-icons/bi";
import { PiMicrosoftExcelLogoDuotone } from "react-icons/pi";
import ReactPaginate from 'react-paginate';
import * as XLSX from "sheetjs-style";
import * as FileSaver from 'file-saver';
import moment from 'moment';
function EventReport() {
    const navigate = useNavigate();
    let { eventnumber }: any = useParams();
    const [evNumber, setEvNumber] = useState(eventnumber);
    const [filter, setFilter] = useState({ keyword: "", startDate: "", endDate: "", building: "", status: "", offset: 0, limit: 30 });
    const [empId, setEmpId] = useState("");
    const [eventId, setEventId] = useState("00");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [tempEmpId, setTempEmpId] = useState("");
    const [memberLists, setMemberLists] = useState({ memberLists: [], offset: 0, limit: 5, totalPages: 0, total: 0 });
    const [isExporting, setIsExporting] = useState(false);
    const [statusCounts, setStatusCounts] = useState({ registered: 0, unregistered: 0, total: 0 });
    const auths = {
        headers: {
            "Content-type": "application/json",
            'Authorization': 'Bearer ' + sessionStorage.getItem("accessToken")
        }
    }

    const hendleFilter = (e: any) => {
        const { value, name } = e.target
        setFilter(oldValues => ({ ...oldValues, [name]: value }));
    }
    const onSearch = () => {
        loadData();
    }

    const convertToG7 = (date: any) => {
        if (!date || date === null || date === undefined || date === '') {
            return '';
        }
        
        let formattedDate;
        
        if (typeof date === 'string' && date.includes('Z')) {
            formattedDate = moment(date);  // 'Z' means UTC in ISO format, moment will handle it automatically
        } else {
            formattedDate = moment.utc(date); // Treat it as UTC
        }
        return formattedDate.utcOffset('+07:00').format('DD-MM-YYYY HH:mm:ss');
    };
    
    const loadData = () => {
        setLoading(true);
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/events/eventactive?eventNumber=' + eventnumber,auths)
            .then(function (response) {
                if (response !== null) {
                    loadMember(response.data.id);
                    setEventId(response.data.id);
                }
                setSuccess(true)
                console.log(response);
            })
            .catch(function (error) {
                setSuccess(true)
                console.log(error);
                setLoading(false);
            })
            .finally(function () {
                // always executed
            });
    }
    const loadMember = (id: number) => {
        axios.get(process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + "&&keyword=" + filter.keyword + "&&status=" + filter.status + "&&offset=" + filter.offset + "&limit=" + filter.limit,auths)
            .then(function (response) {
                setMemberLists(response.data);
                
                // โหลด totals เฉพาะกรณีที่ไม่ได้ค้นหาตามรหัสพนักงาน
                if (!filter.keyword || filter.keyword.trim() === "") {
                    loadStatusCounts(id);
                } else {
                    // เคลียร์ค่าเพื่อไม่ให้แสดงค่าค้าง
                    setStatusCounts({ registered: 0, unregistered: 0, total: 0 });
                }

                console.log(response);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            })
            .finally(function () {
                setLoading(false);
            });
    }
    
    const loadStatusCounts = (id: number) => {
        const kw = encodeURIComponent(filter.keyword || '');
        const base = process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + id + '&&keyword=' + kw;
        const allReq = axios.get(base + '&&status=&&offset=0&limit=1', auths);
        const registeredReq = axios.get(base + '&&status=1&&offset=0&limit=1', auths);

        Promise.all([allReq, registeredReq])
            .then(([allRes, regRes]) => {
                const apiTotal = allRes.data?.total ?? 0;
                const registered = regRes.data?.total ?? 0;
                let unregistered = apiTotal - registered;
                if (unregistered < 0) unregistered = 0;
                setStatusCounts({ registered, unregistered, total: apiTotal });

                if ((registered + unregistered) !== apiTotal) {
                    console.log('Summary mismatch with API total (computed from diff):', { apiTotal, registered, unregistered });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }
    
    const handlePageClick = (event: any) => {
        const newOffset = (event.selected * filter.limit) % memberLists.total;
        console.log(
            `User requested page number ${event.selected}, which is offset ${newOffset}`
        );
        setFilter(oldValues => ({ ...oldValues, ['offset']: newOffset }));
    }
    const onExport = async () => {
        setIsExporting(true);
        const fileName: string = "Events Report"
        
        try {
            // Fetch all data for export
            const response = await axios.get(process.env.REACT_APP_API_END_POINT + '/v1/member/Members?eventId=' + eventId + "&&keyword=" + filter.keyword + "&&status=" + filter.status + "&&offset=0&limit=999999",auths);
            
            const exportData = response.data.memberLists.map((item: any) => ({
                'Employee Id': item.employeeId,
                'Substitute(รับแทน)': item.takeRecieved,
                'Item Name': item.rewardName,
                'Name': item.namempt,
                'Department': item.namcenttha,
                'Email': item.email,
                'Building': item.codcom2,
                'Location': item.codcom1,
                'Register Date': convertToG7(item.updatedAt),
                'Status': (item.recieved === "1") ? "ลงทะเบียนเรียบร้อย" : "ยังไม่ลงทะเบียน",
            }));

            // Create workbook and worksheet
            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(exportData);
            
            // Add worksheet to workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, "Employee");
            
            // Generate buffer and save file
            XLSX.writeFile(workbook, fileName + '.xlsx');
            
        } catch (error) {
            console.log(error);
        } finally {
            setIsExporting(false);
        }
    }
    useEffect(() => {
        loadData()
    }, [filter.offset])
    useEffect(() => {
        setFilter(old => ({ ...old, offset: 0 }));
        loadData();
    }, [filter.keyword, filter.status]);
    return (
        <>
            <UserTopbar />
            <div className='container-fluid mt-3'>
                <div className='row'>
                    <div className='col-12'>
                        <div className='card report-filter p-3'>
                            <div className='row align-items-end'>
                                <div className='col-3'>
                                    <div className="mb-0">
                                        <label className="form-label fw-bold">Search</label>
                                        <input type="text" name='keyword' className="form-control" placeholder="ค้นหาตามรหัสพนักงาน" onChange={(e: any) => hendleFilter(e)} value={filter.keyword} />
                                    </div>
                                </div>
                                <div className='col-2'>
                                    <div className="mb-0">
                                        <label className="form-label fw-bold">Status</label>
                                        <select className="form-select" name='status' value={filter.status} onChange={(e: any) => hendleFilter(e)}>
                                            <option value="">-- ทั้งหมด --</option>
                                            <option value="0">ยังไม่ลงทะเบียน</option>
                                            <option value="1">ลงทะเบียนแล้ว</option>
                                        </select>
                                    </div>
                                </div>
                                <div className='col-3'>
                                    <button className="btn btn-add me-2" onClick={() => onSearch()}>
                                        <BiSearchAlt size={26} />
                                    </button>
                                    <div className="mb-0 d-none">
                                        <label className="form-label fw-bold">Register Date</label>
                                        <DateRangePicker>
                                            <input type="text" className="form-control" />
                                        </DateRangePicker>
                                    </div>

                                </div>
                                <div className='col-2'>
                                    <div className="mb-0  d-none">
                                        <label className="form-label fw-bold">Building</label>
                                        <select className="form-select" >
                                            <option value="1">AAA</option>
                                            <option value="2">BB</option>
                                            <option value="3">LPN</option>
                                        </select>
                                    </div>
                                </div>

                                <div className='col-2 text-end'>
                                <button className="btn btn-export" onClick={onExport} disabled={isExporting}>
                                    {isExporting ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            กำลัง Export...
                                        </>
                                    ) : (
                                        <>
                                            <PiMicrosoftExcelLogoDuotone size={26} /> <span>Export</span>
                                        </>
                                    )}
                                </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(!filter.keyword || filter.keyword.trim() === "") && (
                    <div className='col-12 mt-3'>
                        <div className='card p-3'>
                            <div className='row text-center'>
                                <div className='col-4'>
                                    <div className='border-end'>
                                        <h5 className='text-primary mb-1'>{statusCounts.total}</h5>
                                        <small className='text-muted'>รวมทั้งหมด</small>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className='border-end'>
                                        <h5 className='text-success mb-1'>{statusCounts.registered}</h5>
                                        <small className='text-muted'>ลงทะเบียนแล้ว</small>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div>
                                        <h5 className='text-danger mb-1'>{statusCounts.unregistered}</h5>
                                        <small className='text-muted'>ยังไม่ลงทะเบียน</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}
                    <div className='col-12'>
                        <table className="table user-table  mt-4">
                            <thead className='tbl-header'>
                                <tr>
                                    <th scope="col">Employee Id</th>
                                    <th scope="col">Substitute(รับแทน)</th>
                                    <th scope="col">Employee Name</th>
                                    <th scope="col">Item Name</th>
                                    <th scope="col">Building</th>
                                    <th scope="col">Department</th>
                                    <th scope="col">Register Date</th>
                                    <th scope="col">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    loading ? (
                                        <tr>
                                            <td colSpan={8} className="text-center py-4">
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                กำลังโหลดข้อมูล...
                                            </td>
                                        </tr>
                                    ) : (
                                        (memberLists.memberLists.length > 0) ?
                                            memberLists.memberLists.map(
                                                (item: any,
                                                    index: number) => (
                                                    <tr className={`${(item.recieved === "1") ? "tr-registered" : "tr-unregister"}`}>
                                                        <td>{item.employeeId}</td>
                                                        <td>{item.takeRecieved}</td>
                                                        <td>{item.namempt}</td>
                                                        <td>{item.rewardName}</td>
                                                        <td>{item.codcom2}</td>
                                                        <td>{item.namcenteng}</td>
                                                        <td>
                                                            {convertToG7(item.updatedAt)}
                                                        </td>
                                                        <td className={`${(item.recieved === "1") ? "text-success" : "text-danger"}`}>
                                                            {
                                                                (item.recieved === "1") ?
                                                                    <>ลงทะเบียนเรียบร้อย</>
                                                                    :
                                                                    <>ยังไม่ลงทะเบียน</>
                                                            }

                                                        </td>
                                                    </tr>
                                                )
                                            )
                                            :
                                            <></>
                                    )
                                }

                            </tbody>
                        </table>
                        <ReactPaginate
                            className='pagination justify-content-end'
                            breakLabel="..."
                            nextLabel=">"
                            onPageChange={(e: any) => handlePageClick(e)}
                            pageRangeDisplayed={5}
                            pageCount={memberLists.totalPages}
                            previousLabel="<"
                            renderOnZeroPageCount={null}
                            pageClassName='page-item'
                            pageLinkClassName='page-link'
                            activeClassName='active'
                            previousClassName='page-item'
                            nextClassName='page-item'
                            previousLinkClassName='page-link'
                            nextLinkClassName='page-link'
                        />
                    </div>
                </div>
            </div >
        </>
    )
}

export default EventReport
